import React from 'react';

import { Box } from '@mui/material';

import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

interface ITimerActionButtonProps extends IBaseActionButtonProps {
  active: boolean;
}
const TimerActionButton = (props: ITimerActionButtonProps) => {
  const { active, ...rest } = props;
  const { classes } = useStyles({ active });

  return (
    <BaseActionButton styles={{ position: 'relative' }} {...rest}>
      <TimerOutlinedIcon />
      {active && <Box className={classes.activeMarker} />}
    </BaseActionButton>
  );
};

export default TimerActionButton;
